import { useEffect, useState } from 'react'
import { requestExtensionRedeem, verifyClipboardCheckout } from '../lib/clipboardCheckout'

type Status = 'working' | 'ready' | 'error'

export function ClipboardActivated() {
  const params = new URLSearchParams(window.location.search)
  const sessionId = params.get('session_id')
  const restoreToken = params.get('restore')
  const [status, setStatus] = useState<Status>('working')
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    document.title = 'JOT Clipboard — unlocked'

    async function run() {
      try {
        if (sessionId) {
          await verifyClipboardCheckout(sessionId)
        } else if (!restoreToken) {
          setError('Missing payment or restore link.')
          setStatus('error')
          return
        }

        requestExtensionRedeem({
          sessionId: sessionId ?? undefined,
          restoreToken: restoreToken ?? undefined,
        })
        const again = window.setInterval(() => {
          requestExtensionRedeem({
            sessionId: sessionId ?? undefined,
            restoreToken: restoreToken ?? undefined,
          })
        }, 1500)
        window.setTimeout(() => window.clearInterval(again), 12000)
        setStatus('ready')
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Could not confirm payment')
        setStatus('error')
      }
    }

    void run()
  }, [sessionId, restoreToken])

  return (
    <div className="lp lp--extension">
      <nav className="lp-nav">
        <div className="lp-nav-inner">
          <a href="/home" className="lp-wordmark">JOT</a>
        </div>
      </nav>
      <section className="lp-hero">
        <div className="lp-hero-inner clip-buy">
          <p className="lp-hero-eyebrow">JOT Clipboard</p>
          {status === 'working' && <h1 className="lp-hero-headline">Confirming…</h1>}
          {status === 'ready' && (
            <>
              <h1 className="lp-hero-headline">Unlocked on this computer.</h1>
              <p className="lp-hero-body">
                The extension should switch to full history in a few seconds.
                If search still shows seven days, open the toolbar popup or
                reload the extension, then reopen this page.
              </p>
              <p className="lp-hero-proof">
                Bookmark this page if you reinstall Chrome — it is also your restore link.
              </p>
            </>
          )}
          {status === 'error' && (
            <>
              <h1 className="lp-hero-headline">Could not unlock.</h1>
              <p className="lp-hero-body">{error}</p>
              <p className="clip-buy-restore">
                <a href="/subscribe">Back to checkout</a>
                {' · '}
                <a href="/extension/restore">Restore instead</a>
              </p>
            </>
          )}
        </div>
      </section>
    </div>
  )
}
